(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tdo-event-behaviors"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function pad(n) {
      return String(Math.max(0, n)).padStart(2, '0');
    }

    function initCountdown() {
      var root = document.querySelector('[data-tdo-countdown]');
      if (!root) return;
      var deadline = new Date(root.getAttribute('data-tdo-countdown')).getTime();
      if (isNaN(deadline)) return;
      var days = root.querySelector('[data-tdo-cd-days]');
      var hours = root.querySelector('[data-tdo-cd-hours]');
      var mins = root.querySelector('[data-tdo-cd-minutes]');
      var secs = root.querySelector('[data-tdo-cd-seconds]');
      var set = function (el, value) {
        if (el && el.textContent !== value) el.textContent = value;
      };
      var tick = function () {
        var ms = Math.max(0, deadline - Date.now());
        set(days, pad(Math.floor(ms / 864e5)));
        set(hours, pad(Math.floor(ms / 36e5) % 24));
        set(mins, pad(Math.floor(ms / 6e4) % 60));
        set(secs, pad(Math.floor(ms / 1e3) % 60));
      };
      tick();
      setInterval(tick, 1000);
    }

    function initReveals() {
      var els = Array.prototype.slice.call(document.querySelectorAll('[data-tdo-reveal]'));
      if (!els.length) return;
      if (reduceMotion) {
        els.forEach(function (el) {
          el.style.opacity = '1';
          el.style.transform = 'none';
        });
        return;
      }
      els.forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'opacity .8s var(--tdo-ease), transform .8s var(--tdo-ease)';
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'none';
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      els.forEach(function (el) { io.observe(el); });
    }

    function initParallax() {
      if (reduceMotion) return;
      var heroBg = document.getElementById('tdo-hero-bg');
      var venueImg = document.getElementById('tdo-venue-img');
      if (!heroBg && !venueImg) return;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (heroBg) heroBg.style.transform = 'translateY(' + y * 0.3 + 'px)';
        if (venueImg) {
          var rect = venueImg.parentElement.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) {
            venueImg.style.objectPosition = '50% ' + (50 + (rect.top / window.innerHeight) * 12) + '%';
          }
        }
      }, { passive: true });
    }

    function initFaq() {
      document.querySelectorAll('[data-tdo-faq]').forEach(function (item) {
        var button = item.querySelector('[data-tdo-faq-trigger]');
        var body = item.querySelector('[data-tdo-faq-body]');
        var chev = item.querySelector('[data-tdo-faq-chevron]');
        if (!button || !body) return;
        button.addEventListener('click', function () {
          var open = body.style.maxHeight && body.style.maxHeight !== '0px';
          body.style.maxHeight = open ? '0px' : body.scrollHeight + 'px';
          button.setAttribute('aria-expanded', String(!open));
          if (chev) chev.style.transform = open ? 'none' : 'rotate(45deg)';
        });
      });
    }

    function initRegistrationTicket() {
      var root = document.querySelector('[data-tdo-registration-form]');
      if (!root) return;
      var radios = Array.prototype.slice.call(root.querySelectorAll('[data-tdo-ticket]'));
      if (!radios.length) return;
      var priceEl = document.querySelector('[data-tdo-live-price]');
      var ctaSuffixEl = root.querySelector('[data-tdo-cta-suffix]');
      var compareEl = document.querySelector('[data-tdo-compare-price]');
      var saveEl = document.querySelector('[data-tdo-save-label]');
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          var price = radio.getAttribute('data-tdo-price');
          var compare = radio.getAttribute('data-tdo-compare');
          var save = radio.getAttribute('data-tdo-save');
          if (priceEl) priceEl.textContent = price;
          if (ctaSuffixEl) ctaSuffixEl.textContent = ' · ' + price;
          if (compareEl) {
            if (compare) {
              var s = compareEl.querySelector('s');
              if (s) s.textContent = compare;
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }
          if (saveEl) saveEl.textContent = save;
        });
      });
    }

    function initAgendaForm() {
      var wrapper = document.querySelector('[data-tdo-agenda-form]');
      if (!wrapper) return;
      var form = wrapper.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', function (event) {
        if (!window.fetch) return;
        event.preventDefault();
        var fields = wrapper.querySelector('[data-tdo-agenda-fields]');
        var done = wrapper.querySelector('[data-tdo-agenda-done]');
        var formData = new FormData(form);
        fetch(form.action, {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        }).finally(function () {
          if (fields) fields.style.display = 'none';
          if (done) done.style.display = 'block';
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initCountdown();
      initReveals();
      initParallax();
      initFaq();
      initAgendaForm();
      initRegistrationTicket();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
